// extracted by mini-css-extract-plugin
export var attribution = "_b5-4";
export var authorName = "_b5-5";
export var quote = "_b5-3";
export var testimonial = "_b5-2";
export var trustedBy = "_b5-0";
export var trustedByLabel = "_b5-1";